import React from "react";
import { useSettings, useLang } from "../lib/providers";

export default function ReassuranceBlock({ compact = false, variant }) {
  const { settings } = useSettings();
  const { lang } = useLang();
  if (!settings?.reassurance_enabled) return null;
  const items = settings.reassurance_items || [];
  if (items.length === 0) return null;

  const waPhone = (settings.whatsapp_dz || "").replace(/\D/g, "");
  const waLink = waPhone ? `https://wa.me/${waPhone}` : null;
  const mode = variant || (compact ? "lines" : "cards");

  if (mode === "lines") {
    return (
      <section
        className={`${compact ? "py-3" : "py-6"} bg-neon/5 border-y border-neon/20`}
        data-testid="reassurance-block"
      >
        <div className="max-w-3xl mx-auto px-4 sm:px-6">
          <ul className="divide-y divide-neon/10">
            {items.map((it, i) => {
              const text = lang === "ar" ? (it.text_ar || it.text_fr) : (it.text_fr || it.text_ar);
              const isWa = (it.text_fr || "").toLowerCase().includes("whatsapp") || (it.emoji || "").includes("📲");
              const inner = (
                <div className="flex items-center gap-3 py-2" data-testid={`reassurance-item-${i}`}>
                  <span className="text-base shrink-0 w-5 text-center" aria-hidden>{it.emoji || "•"}</span>
                  <p className="text-xs sm:text-sm text-white/85 leading-snug">{text}</p>
                </div>
              );
              return (
                <li key={i}>
                  {isWa && waLink
                    ? <a href={waLink} target="_blank" rel="noreferrer" className="block hover:bg-neon/5 transition-colors -mx-2 px-2">{inner}</a>
                    : inner}
                </li>
              );
            })}
          </ul>
        </div>
      </section>
    );
  }

  // cards mode (default for homepage)
  return (
    <section className="py-12 sm:py-16 bg-neon/5 border-y border-neon/20" data-testid="reassurance-block">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid gap-3 sm:gap-4 sm:grid-cols-2 lg:grid-cols-5">
          {items.map((it, i) => {
            const text = lang === "ar" ? (it.text_ar || it.text_fr) : (it.text_fr || it.text_ar);
            const isWa = (it.text_fr || "").toLowerCase().includes("whatsapp") || (it.emoji || "").includes("📲");
            const inner = (
              <div className="flex items-start gap-3 p-3 sm:p-4 border border-neon/30 bg-black/40 h-full hover:border-neon transition-colors" data-testid={`reassurance-item-${i}`}>
                <span className="text-2xl shrink-0" aria-hidden>{it.emoji || "•"}</span>
                <p className="text-xs sm:text-sm text-white/90 leading-relaxed font-medium">{text}</p>
              </div>
            );
            return isWa && waLink
              ? <a key={i} href={waLink} target="_blank" rel="noreferrer">{inner}</a>
              : <div key={i}>{inner}</div>;
          })}
        </div>
      </div>
    </section>
  );
}
